var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorktualSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4.99208C28 2.24089 25.7767 0 23.0472 0H9.47642V9.11886H0V18.8922H9.69654L18.7327 28V18.8811H28V4.98098V4.99208ZM9.69654 9.78447L18.5126 18.6704H9.69654V9.78447ZM18.5126 27.4786L10.0047 18.9033H18.5126V27.4786ZM27.7799 18.6704H18.7437V14.3217C18.7437 11.4485 16.4214 9.10777 13.5708 9.10777H9.70755V0.22187H23.0582C25.6667 0.22187 27.7909 2.36292 27.7909 4.99208V18.6704H27.7799Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorktualSmall);
export default __webpack_public_path__ + "static/media/worktual-small.d22a5487ef3276c5ae0d9c8f4b408244.svg";
export { ForwardRef as ReactComponent };